import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import SupplierWorkOrderEditForm from '../supplier_work_order_edit_form/SupplierWorkOrderEditForm';
import { workOrdersRestCrudThunksForSupplier } from '../../thunks/work_orders_thunks';
import { EditPage } from '../edit_page/EditPage';
import { goBackLink, recursiveRemovePreserve } from '../../utils/HistoryUtils';
import { getWorkOrderSelector } from '../../selectors/workOrderSelectors';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import { getEntityById } from '../../utils/DataAccessUtils';

const queryString = require('qs');
require('./SupplierApproveWorkOrderPage.less');

class SupplierApproveWorkOrderPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
		this.state = {
			fetching: true,
		};
	}
	componentDidMount() {
		const { getWorkOrder, match } = this.props;
		const workOrderId = match.params.id;
		getWorkOrder(workOrderId).then(() => {
			this.setState({ fetching: false });
		});
	}

	render() {
		const { history, workOrder, location } = this.props;
		const { fetching } = this.state;
		const defaultUrlPath = `/supplier/workOrders/detail/${workOrder.id}/details`;

		if (fetching) {
			return <PageLoadingPlaceholder />;
		}

		return (
			<EditPage
				title="Approve Work Order"
				formComponentProps={{
					formData: workOrder,
					isApprovalForm: true,
					onSuccess: (rec) => {
						let string = goBackLink(location, defaultUrlPath);
						const [path, queryParams] = string.split('?');
						let urlSearchParams = queryString.parse(queryParams);
						history.push(`${path}?${recursiveRemovePreserve(urlSearchParams)}`);
					},
				}}
				fetching={fetching}
				FormComponent={SupplierWorkOrderEditForm}
			/>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		history: ownProps.history,
		workOrder: getEntityById(ownProps.match.params.id, state.work_orders),
		match: ownProps.match,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getWorkOrder: (id) => dispatch(workOrdersRestCrudThunksForSupplier.readOne(id)),
});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(SupplierApproveWorkOrderPage)
);
